import { CircularProgress, Grid, Tab, Tabs } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import '../../../scss/UVP.scss';
import { CreditCardTypeEnum } from '../../../services/V2/gozer';
import { authProvider } from '../../../services/Security';
import { BillingAccountsVService, TokensVService, TokenType } from '../../../services/V2/gozer';
import { DistrictsVService, ModuleConfigsVService } from '../../../services/V2/padre';
import { handleErrorToast } from '../../shared/Functions';
import { PaymentFlowPage1 } from './PaymentFlowPage1';
import { PaymentFlowPage2 } from './PaymentFlowPage2';
import { PaymentFlowPage3 } from './PaymentFlowPage3';

export const PaymentFlow = ({ successToast, errorToast }) => {
    const [loading, setLoading] = useState<boolean>(true);
    const [district, setDistrict] = useState<any>();
    const [districtId, setDistrictId] = useState<any>();
    const [billingAccount, setBillingAccount] = useState<any>();
    const [billingAccountId, setBillingAccountId] = useState<any>();
    const [amount, setAmount] = useState<any>();
    const [tokens, setTokens] = useState<any>();
    const [paymentToken, setPaymentToken] = useState<any>();
    const [token, setToken] = useState<any>();
    const [selectedTab, setSelectedTab] = useState<number>(0);
    const [newPayment, setNewPayment] = useState<any>({
        ach: false,
        terminal: false
    });
    const [fee, setFee] = useState<number>(0);
    const [newEmail, setEmail] = useState<any>();
    const [paymentMade, setPaymentMade] = useState<any>();
    const [paymentConfigs, setPaymentConfigs] = useState<any>();
    const [hasError, setHasError] = useState<boolean>(false);
    const [frameClosed, setFrameClosed] = useState<boolean>(false);
    const [districtModules, setDistrictModules] = useState<any>();
    const [paymentMode, setPaymentMode] = useState<string | null>(null);

    window.addEventListener('message', event => {
        // IMPORTANT: check the origin of the data!
        if (!event.data) return;
        try{
            var data = JSON.parse(event?.data);
            authProvider.setToken(data?.token)
            setDistrictId(data?.districtId)
            setBillingAccountId(data?.billingAccountId)
            setAmount(data?.amount)
            setToken(data?.token)
            setLoading(false)
        } catch{
        }
    });

    useEffect(() => {
        if (!token || !districtId || !billingAccountId || !loading || selectedTab !== 0) return;
        DistrictsVService.districtsVGetById(districtId ?? "")
            .then(x => setDistrict(x))
            .catch(x => errorToast(handleErrorToast(x)))
        BillingAccountsVService.billingAccountsVGetById(billingAccountId ?? "")
            .then(account => {
                setBillingAccount(account)
                setPaymentConfigs(account.paymentInfo)
                TokensVService.tokensVGetAll(billingAccountId)
                    .then(x => {
                        setTokens(x.filter(y => {
                            if (y.tokenType === TokenType.ACH) {
                                return (!account.disallowACHPayments && account?.paymentInfo?.ach?.allowPayment) && !y.isThirdParty
                            } else {
                                if (!account?.disallowCCPayments && account?.paymentInfo?.cc?.allowPayment) {
                                    return (y.cardType === CreditCardTypeEnum.AMERICAN_EXPRESS && account?.paymentInfo?.cc?.acceptAmex) ||
                                        (y.cardType === CreditCardTypeEnum.DISCOVER && account?.paymentInfo?.cc?.acceptDiscover) ||
                                        (y.cardType === CreditCardTypeEnum.MASTER_CARD && account?.paymentInfo?.cc?.acceptMasterCard) ||
                                        (y.cardType === CreditCardTypeEnum.VISA && account?.paymentInfo?.cc?.acceptVisa)
                                }
                                return false;
                            }
                        }))
                        setPaymentToken(x.find(x => x.isPrimary));
                    })
            })
            .catch(x => errorToast(handleErrorToast(x)))
        ModuleConfigsVService.moduleConfigsVGetDistrictModuleConfig(districtId)
            .then((x: any) => {
                setDistrictModules(x);
                setLoading(false)
            })
            .catch(x => errorToast(handleErrorToast(x)))
    }, [token])// eslint-disable-line react-hooks/exhaustive-deps

    const handleChange = (e, tab) => {
        setSelectedTab(tab)
    }

    const cancel = () => {
        setBillingAccount(null)
        setTokens(null)
        setDistrict(null)
        setSelectedTab(0)
        setFrameClosed(true)
    }

    return (
        <React.Fragment>
            {billingAccount && !districtModules.ePayments ?
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "542px", width: "1100px" }}>
                    Electronic payments have been disabled and are not allowed.
                    <br />
                    You may now close this window.
                </div>
                :
                billingAccount && district ? (
                    <div style={{ backgroundColor: "#F5F5F5", textAlign: "left", height: "542px", width: "1100px", padding: "20px" }}>
                        <Tabs
                            className='uvp-tab-bar'
                            style={{ backgroundColor: "#F5F5F5" }}
                            value={selectedTab}
                            onChange={handleChange}
                            TabIndicatorProps={{ style: { backgroundColor: "#3F8A3D", height: "4px" } }}
                        >
                            <Tab className='uvp-tabs' label="Payment Method" disabled={selectedTab !== 0} style={{ backgroundColor: selectedTab === 0 ? "white" : "#E0E0E0", fontWeight: selectedTab === 0 ? "bold" : "normal" }}></Tab>
                            <Tab className='uvp-tabs' label="Review" disabled={selectedTab !== 1} style={{ backgroundColor: selectedTab === 1 ? "white" : "#E0E0E0", fontWeight: selectedTab === 1 ? "bold" : "normal" }}></Tab>
                            <Tab className='uvp-tabs' label="Confirmation" disabled={selectedTab !== 2} style={{ backgroundColor: selectedTab === 2 ? "white" : "#E0E0E0", fontWeight: selectedTab === 2 ? "bold" : "normal" }}></Tab>
                        </Tabs>
                        <Grid container style={{ backgroundColor: "white", height: "467px" }}>
                            {selectedTab === 0 && (
                                <PaymentFlowPage1
                                    successToast={successToast}
                                    errorToast={errorToast}
                                    district={district}
                                    billingAccount={billingAccount}
                                    paymentConfigs={paymentConfigs}
                                    tokens={tokens}
                                    paymentToken={paymentToken}
                                    setPaymentToken={setPaymentToken}
                                    cancel={cancel}
                                    amount={amount}
                                    setAmount={setAmount}
                                    selectedTab={selectedTab}
                                    setSelectedTab={setSelectedTab}
                                    hasError={hasError}
                                    setHasError={setHasError}
                                    paymentMode={paymentMode}
                                    setPaymentMode={setPaymentMode}
                                    setNewPaymentMain={(data) => setNewPayment(data)}
                                    newEmail={newEmail}
                                    setEmail={setEmail}
                                    setTerminalResult={setPaymentMade} />
                            )}
                            {selectedTab === 1 &&
                                <PaymentFlowPage2
                                    errorToast={errorToast}
                                    billingAccount={billingAccount}
                                    paymentToken={paymentToken}
                                    cancel={cancel}
                                    amount={amount}
                                    selectedTab={selectedTab}
                                    setSelectedTab={setSelectedTab}
                                    hasError={hasError}
                                    newPayment={newPayment}
                                    newEmail={newEmail}
                                    setPaymentMade={setPaymentMade}
                                    setMainFee={setFee} />
                            }
                            {selectedTab === 2 &&
                                <PaymentFlowPage3
                                    successToast={successToast}
                                    errorToast={errorToast}
                                    district={district}
                                    billingAccount={billingAccount}
                                    paymentToken={paymentToken}
                                    cancel={cancel}
                                    amount={amount}
                                    newPayment={newPayment}
                                    newEmail={newEmail}
                                    tokens={tokens}
                                    fee={fee}
                                    paymentMade={paymentMade} />
                            }
                        </Grid>
                        {loading &&
                            <div className='loading-container'><CircularProgress color="primary" className='center-spinner' /></div>
                        }
                    </div>
                )
                    : !frameClosed ?
                        <div className='loading-container'><CircularProgress color="primary" className='center-spinner' /></div>
                        :
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "542px", width: "1100px" }}>
                            You may now close this window
                        </div>
            }
        </React.Fragment>
    )
}